import React from 'react';
import { FiCalendar, FiCodesandbox, FiServer } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ConsulenzaList = [
    {
        icon: <FiCalendar />,
        title: 'Project Manager',
        description: 'Ti serve un <span class=\'highlighted\'>responsabile unico dell\'avvio, pianificazione, esecuzione, controllo e chiusura</span> di un progetto?<br />Allora facciamo al caso tuo.<br />Abbiamo già ricoperto questo ruolo in passato per diverse realtà, contattaci e ti mostreremo tutto quello che abbiamo fatto.'
    },
    {
        icon: <FiCodesandbox />,
        title: 'Senior Developer',
        description: 'Ti serve un <span class=\'highlighted\'>programmatore esperto e sempre al passo sulle nuove tecnologie in grado di aiutarti nell\'analisi</span> e ad avere una visione d\'insieme del tuo progetto?<br />Mettici alla prova.<br />Non esiste linguaggio di programmazione che non sappiamo o che non possiamo imparare.'
    },
    {
        icon: <FiServer />,
        title: 'IT Manager',
        description: 'Ti serve una figura che si occupi di <span class=\'highlighted\'>pianificare, progettare e gestire i sistemi di information technology (IT)</span> della tua azienda?<br />Allora possiamo esserti utili.<br />Se progetti un aggiornamento hardware o software per la tua azienda contattaci, potremo sicuramente esserti d\'aiuto.'
    },
]

const BoxConsulenza = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ConsulenzaList.map( (val , i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                                <a className="btn-default btn-small round btn-icon mt-5" href={'/contatti?t=Consulenza ' + val.title}>Contattaci</a>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default BoxConsulenza;